import React, { memo } from 'react';
import { motion } from 'framer-motion';
export function OpeningHook() {
  return <section className="w-full bg-white py-16 md:py-20 px-6" data-id="element-61">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="max-w-3xl mx-auto" data-id="element-62">
        <p className="text-lg md:text-xl text-[#1C1C1C] leading-relaxed mb-6 italic" data-id="element-63">
          Entrás a tu casa después de un día agotador. Abrís la puerta, respirás
          profundo y ahí está: ese olor ácido, punzante y sofocante que ya
          conocés de memoria. Mirás el sofá que todavía estás pagando y ves la
          mancha húmeda. Sentís impotencia, bronca y una culpa enorme por estar
          enojado con alguien que amás.
        </p>
        <p className="text-xl md:text-2xl font-['Playfair_Display'] font-semibold text-[#2D8C5A] text-center" data-id="element-64">
          No sos vos, y no es tu gato "siendo malo". Es un problema de
          comunicación química que tiene solución.
        </p>
      </motion.div>
    </section>;
}